import _upaload_file from "./src/upload-file";
import _upaload_files from "./src/upload-files";

export const UploadFile = _upaload_file;
export const UploadFiles = _upaload_files;

export default UploadFile
